import moment from 'moment';
import { ADULT } from '../constants/patientAges';

export default function checkUsersAge(birthday){
    return moment(birthday).add(ADULT, 'year') > new Date();
}